module.exports = __webpack_public_path__ + "01ae3678.webp";